export default "__VITE_ASSET__DV$cEaa6__"